export default __webpack_public_path__ + "static/media/betting-history.a097b1fb.svg";